import React from "react";

import {
  Button,
  ButtonVariant,
  Tooltip,
} from "@patternfly/react-core";

import { bipService } from "../services/bipService";
import { LOGO_SIZES } from "../../../../../../shared/constants/logoSizes";

const SchoolHeaderBip = ({ variant = "desktop" }) => {
  const bip = bipService.getBip(variant);

  if (!bip) {
    return null;
  }

  const image = (
    <img
      src={bip.logo.src}
      alt={bip.label}
      loading="lazy"
      style={{
        height: `${bip.logo.height ?? LOGO_SIZES[variant][bip.logo.size]}px`,
        width: "auto",
        display: "block",
        ...(bip.logo.offset && {
          transform: `translate(${bip.logo.offset.x}px, ${bip.logo.offset.y}px)`,
        }),
      }}
    />
  );

  const content = bip.tooltip ? (
    <Tooltip content={bip.tooltip}>
      {image}
    </Tooltip>
  ) : (
    image
  );

  return (
    <Button
      component="a"
      variant={ButtonVariant.plain}
      href={bip.href}
      target={bip.external ? "_blank" : undefined}
      rel={bip.external ? "noopener noreferrer" : undefined}
      aria-label={bip.label}
      isInline
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }}
    >
      {content}
    </Button>
  );
};

export default SchoolHeaderBip;